<div class="position-abs simple-dropdown search">
    <div class=" centered-column-container ">
        <app-input #searchInput
                    [autofocus]="true"
                    [input]="searchValue"
                    [inputID]="'searchInput'"
                    [placeholder]="'Search'"
                    [prefixFirstIcon]="'search.svg'"
                    [suffixFirstIcon]="'close.svg'"
                    (inputChange)="searchValue=$event"
                    (blurEmitter)="emitChanges($event)"
                    (suffixFirstIconEmitter)="cancelEmit()"
                    (keyup.enter)="emitChanges(searchValue)">
        </app-input>
    </div>
</div>
